import _ from 'lodash'
import $ from 'jquery'
import { unref } from 'vue'

function getJsFunction({ store }: any) {
  return {
    getUserInfo: () => {
      const token = JSON.parse(localStorage.getItem('authentication') || '{}')?.token
      return {
        ..._.pick(_.get(store.state, 'user.user'), [
          'companyCode',
          'companyId',
          'companyName',
          'companyRole',
          'id',
          'userCode',
          'userName'
        ]),
        token
      }
    }
  }
}

function registerJsFunction(scope: any) {
  if (_.isNil(_.get(window, 'fcWidgetMessengerConfig'))) {
    _.set(window, 'fcWidgetMessengerConfig', {})
  }

  _.assign(_.get(window, 'fcWidgetMessengerConfig'), { jsFunctions: getJsFunction(scope) })
}

function init({ language, store }: any) {
  let domain = process.env.VUE_APP_CHATBOT_URL_DEVELOP
  if (_.isEmpty(domain)) {
    domain = window.location.origin
  }

  const fcWidget = _.get(window, 'fcWidget') as any
  if (!fcWidget.isInitialized()) {
    fcWidget.init({})
  }

  fcWidget.conversation.setBotVariables({
    api_domain: domain,
    user_name: _.get(store.state, 'user.user.userName')
  })
}

function listenFcWidget(loop: number) {
  let count = 0
  function test(resolve: any, reject: any) {
    if (!_.isNil(_.get(window, 'fcWidget'))) {
      return resolve(true)
    }

    if (count > loop) {
      return reject(new Error('time out'))
    }
    count++
    setTimeout(() => test(resolve, reject), 100)
  }
  return new Promise(test)
}

const LISTEN_FC_WIGET_LOOP_NUM = 600

export function loadChatbotScript(chatbotId: string, scope: any) {
  registerJsFunction(scope)

  _.assign(_.get(window, 'fcWidgetMessengerConfig'), { locale: unref(scope.language) })

  if ($(`head > script[id=${chatbotId}]`).length > 0) {
    init(scope)
    return
  }

  const script = document.createElement('script')
  $(script).attr({
    id: chatbotId,
    chat: 'true',
    src: process.env.VUE_APP_CHATBOT_SRC,
    widgetId: process.env.VUE_APP_CHATBOT_WIDGET_ID
  })

  script.onload = async () => {
    await listenFcWidget(LISTEN_FC_WIGET_LOOP_NUM)
    init(scope)
  }
  document.head.appendChild(script)
}

export function destoryChatbot() {
  const fcWidget = _.get(window, 'fcWidget') as any
  if (!fcWidget) {
    return
  }
  fcWidget.hide()
}

export function showChatbot(chatbotId: string, scope: any) {
  const fcWidget = _.get(window, 'fcWidget') as any
  if (!fcWidget) {
    loadChatbotScript(chatbotId, scope)
    return
  }
  fcWidget.show()
}
